import React from 'react';
import { PrescriberNumberIcon } from '../Components/Icons';
import { iconLight } from '../Styles/Colours';
import { joinLookupIdentifierNamesWithCommas } from '../Shared/SharedModels';
import styles from './AuthorisingPrescriberMenuItem.module.css';
import classNames from 'classnames';
export var AuthorisingPrescriberMenuItem = function (props) {
    var _a;
    var _b, _c, _d;
    var nameClasses = classNames(styles.name, (_a = {},
        _a[styles.nameSelected] = props.selected,
        _a));
    return (React.createElement("div", { className: styles.authorisingPrescriber },
        React.createElement("div", { className: styles.nameAndRoles },
            React.createElement("div", { className: nameClasses }, (_b = props.prescriber.familyName) === null || _b === void 0 ? void 0 :
                _b.toUpperCase(),
                ", ",
                props.prescriber.givenName),
            ((_c = props.prescriber.staffRoles) === null || _c === void 0 ? void 0 : _c.length) > 0 && (React.createElement("div", { className: styles.roles }, joinLookupIdentifierNamesWithCommas(props.prescriber.staffRoles)))),
        React.createElement("div", { className: styles.prescriberNumber },
            React.createElement(PrescriberNumberIcon, { noPadding: true, noCircularContainer: true, size: '18', color: iconLight, style: { marginRight: 10 } }), (_d = props.prescriber.prescriberDetails) === null || _d === void 0 ? void 0 :
            _d.number)));
};
export function renderAuthorisingPrescriberMenuItem(prescriber) {
    return React.createElement(AuthorisingPrescriberMenuItem, { prescriber: prescriber });
}
export function renderAuthorisingPrescriberSuggestion(selectedPrescriber) {
    return function renderAuthorisingPrescriberSuggestionCurried(prescriber) {
        var selected = (selectedPrescriber === null || selectedPrescriber === void 0 ? void 0 : selectedPrescriber.id) === prescriber.id;
        return React.createElement(AuthorisingPrescriberMenuItem, { prescriber: prescriber, selected: selected });
    };
}
export function renderAuthorisingPrescriberSuggestionById(id) {
    return function renderAuthorisingPrescriberSuggestionCurried(prescriber) {
        var selected = id === prescriber.id;
        return React.createElement(AuthorisingPrescriberMenuItem, { prescriber: prescriber, selected: selected });
    };
}
export function renderAuthorisingPrescriberSelected(prescriber) {
    var _a;
    return (React.createElement(React.Fragment, null, (_a = prescriber.familyName) === null || _a === void 0 ? void 0 :
        _a.toUpperCase(),
        ", ",
        prescriber.givenName));
}
